/**
 * Fallacy Color Mapping
 * Maps severity and category to Tailwind color classes
 */

/**
 * Get severity color for badges and indicators
 */
export const getSeverityColor = (severity: string): string => {
  switch (severity) {
    case 'High': return 'bg-red-500';
    case 'Medium': return 'bg-orange-500';
    case 'Low': return 'bg-yellow-500';
    default: return 'bg-slate-500';
  }
};

/**
 * Get category color for badges and indicators
 */
export const getCategoryColor = (category: string): string => {
  switch (category) {
    case 'Formal': return 'bg-blue-500';
    case 'Informal': return 'bg-purple-500';
    case 'Appeal': return 'bg-pink-500';
    case 'Causation': return 'bg-orange-500';
    case 'Ambiguity': return 'bg-teal-500';
    default: return 'bg-slate-500';
  }
};
